import {interpret} from "xstate";
import buttonMachine from "./button-based-tool-xstate.js";
import toolbar from './toolbar.js';

class BaseTool {

    constructor () {
        this.ref = null;
    }

    init (refParam, imgSrc) {
        this.ref = refParam;
        this.ref.base = this;
        this.imgSrc = imgSrc;
    }

    created () {
        this.stateEngine = this.ref.stateEngine;
        this.stateEngine.start();
    }

    mounted () {
        let r = this.ref || this.base;
        r.public = {stateEngine: this.stateEngine, current: this.current};
    }


    data (machine, name) {
        this.stateEngine = this.stateEngine || interpret(machine).onTransition((state,evt) => {
                //console.log("onTransition " + state.value);
                this.ref.current = state.value;
                this.stateChanged(state,evt);
            })
        this.name = name;
        return {
            stateEngine: this.stateEngine,
            name: name,
            current: buttonMachine.initialState.value,
            imageSrc: "",
        };
    }

    stateChanged (state, evt) {
        this.ref.current = state.value;
        this.current = state.value;
        if(this.ref.stateChanged)
            this.ref.stateChanged(state.value, evt);
        if (this.current !== buttonMachine.initialState.value) {
            toolbar.resetOthers(this.ref.$options._componentTag);
            toolbar.setCurrentTool(this.ref)
        }
        toolbar.activateDefault();
        if (this.imgSrc[this.current]) {
            this.ref.imageSrc = this.imgSrc[this.ref.current];
        }
        if (this.ref.imgSrc) {
            this.ref.imageSrc = this.ref.imgSrc[this.ref.current];
        }
        // TODO: aussi créer des cursor (qui seront propagés au canvas)
    }

    sendToStateEngine (event, cmp) {
        cmp.stateEngine.send(event); // || this.base.engine || this.ref.engine
    }

}

export default BaseTool;